import { Component, input, output, inject, OnInit, OnDestroy, signal, ChangeDetectionStrategy } from '@angular/core';
import { EvolutionApiService } from '@core/services/api/evolution-api.service';
import { MicaChatService } from '@shared/services/mica-chat.service';

@Component({
  selector: 'app-mica-chat-qr-conexion',
  imports: [],
  templateUrl: './mica-chat-qr-conexion.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './mica-chat-qr-conexion.css',
})
export class MicaChatQrConexion implements OnInit, OnDestroy {
  private readonly evoApi = inject(EvolutionApiService);
  private readonly micaChatService = inject(MicaChatService);

  telefonoId = input.required<number>();
  conectado = output<void>();

  estado = signal<'conectado' | 'desconectado' | 'conectando'>('desconectado');
  qr = signal<string | null>(null);
  pollingInterval: ReturnType<typeof setInterval> | null = null;

  ngOnInit(): void {
    this.consultarEstado();
    this.pollingInterval = setInterval(() => {
      if (this.estado() !== 'conectado') {
        this.consultarEstado();
      }
    }, 5000);
  }

  ngOnDestroy(): void {
    if (this.pollingInterval) {
      clearInterval(this.pollingInterval);
      this.pollingInterval = null;
    }
  }

  reconectar(): void {
    this.estado.set('conectando');
    this.qr.set(null);
    this.evoApi.reconectarInstancia(this.telefonoId()).subscribe({
      next: (result) => {
        this.estado.set(this.mapEstado(result.estado));
        this.qr.set(result.qr);
        this.syncServiceState();
      },
      error: () => {
        this.estado.set('desconectado');
        this.qr.set(null);
      },
    });
  }

  private consultarEstado(): void {
    this.evoApi.obtenerEstadoConexion(this.telefonoId()).subscribe({
      next: (result) => {
        this.estado.set(this.mapEstado(result.estado));
        this.qr.set(result.qr);
        this.syncServiceState();
        if (result.estado === 'conectado') {
          this.conectado.emit();
        }
      },
      error: () => {
        if (this.estado() === 'desconectado') return;
        this.estado.set('desconectado');
        this.qr.set(null);
      },
    });
  }

  private mapEstado(apiEstado: string): 'conectado' | 'desconectado' | 'conectando' {
    if (apiEstado === 'conectado') return 'conectado';
    if (apiEstado === 'conectando') return 'conectando';
    return 'desconectado';
  }

  private syncServiceState(): void {
    this.micaChatService.setEstadoConexion({
      estado: this.estado(),
      qr: this.qr(),
    });
  }
}
